module.exports = __webpack_public_path__ + "static/img/speaker-city.92bf865a.png";